import { render } from "./CommentaryOverview.vue?vue&type=template&id=72510e36&ts=true"
import script from "./CommentaryOverview.vue?vue&type=script&lang=ts"
export * from "./CommentaryOverview.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__